const PropertyData = [
    {
      id: 1,
      image: 'https://www.investopedia.com/thmb/bfHtdFUQrl7jJ_z-utfh8w1TMNA=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/houses_and_land-5bfc3326c9e77c0051812eb3.jpg',
      location: 'India ,khaguaul',
      state: 'Bihar',
      area: '2000 sq ft',
      price: '$500,000',
    },

    {
      id: 2,
      image: 'https://www.rocketmortgage.com/resources-cmsassets/RocketMortgage.com/Article_Images/Large_Images/Stock-Modern-House-In-Twilight-AdobeStock-368976934-copy.jpg',
      location: 'Los Angeles, USA',
      state: 'California',
      area: '1800 sq ft',
      price: '$450,000',
    },
    {
      id: 3,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTNP5B4x5KDI5hv-OmpcaYrjKgqxqllsqcgecOfhP4Aznlj8anjl8OjFQOlSOyk_M4Tfds&usqp=CAU',
      location: 'Toronto, Canada',
      state: 'Ontario',
      area: '1600 sq ft',
      price: '$550,000',
    },


    {
      id: 4,
      image: 'https://img.staticmb.com/mbcontent/images/uploads/2022/12/Most-Beautiful-House-in-the-World.jpg',
      location: 'New York, USA',
      state: 'New York',
      area: '3000 sq ft',
      price: '$600,000',
    },
    {
      id: 5,
      image: 'https://media.istockphoto.com/id/1067331430/photo/modern-house-with-swimming-pool.webp?b=1&s=170667a&w=0&k=20&c=rmqGQ6SJq05XSMNkYxqNsmo4qALSyw_9fxBar5paRkE=',
      location: 'India , Liluah',
      state: 'Howrah',
      area: '1877 sq ft',
      price: '$4050,000',
    },
    {
      id: 6,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTNP5B4x5KDI5hv-OmpcaYrjKgqxqllsqcgecOfhP4Aznlj8anjl8OjFQOlSOyk_M4Tfds&usqp=CAU',
      location: 'China, hong kong',
      state: 'Ontario',
      area: '3800 sq ft',
      price: '$950,000',
    },


    {
      id: 7,
      image: 'https://thumbs.dreamstime.com/b/luxury-modern-house-swimming-pool-interior-exterior-luxury-house-swimming-pool-interior-exterior-135573030.jpg',
      location: 'India, Aizawal',
      state: 'Mizoram',
      area: '9000 sq ft',
      price: '$1000,000',
    },
    {
      id: 8,
      image: 'https://img.freepik.com/free-photo/luxury-pool-villa-spectacular-contemporary-design-digital-art-real-estate-home-house-property-ge_1258-150765.jpg?w=2000',
      location: 'Australia,Melbourne ',
      state: 'Tasmaina',
      area: '800 sq ft',
      price: '$870,000',
    },
    {
      id: 9,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRS8c0tb8386B7mIbVi8PNZ1g_T8beWrbFmFD8s3FGo8TyQC1acpJ5JPKdpD_b38Ppn82A&usqp=CAU',
      location: 'Bangladesh,Tripura Division ',
      state: 'Barisal',
      area: '9600 sq ft',
      price: '$8550,000',
    },
    {
      id: 10,
      image: 'https://img.freepik.com/premium-photo/building-with-car-front-it_902639-4452.jpg?w=2000',
      location: 'India, IIT delhi road',
      state: 'Delhi',
      area: '3000 sq ft',
      price: '$900,000',
    },
    {
      id: 11,
      image: 'https://archello.s3.eu-central-1.amazonaws.com/images/2018/10/11/Contemporary-Modern-House-Design-6.1539270983.8601.jpg',
      location: 'Los Angeles, USA',
      state: 'California',
      area: '1000 sq ft',
      price: '$350,000',
    },
    {
      id: 12,
      image: 'https://images.unsplash.com/photo-1613977257363-707ba9348227?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8bmV3JTIwaG91c2V8ZW58MHx8MHx8fDA%3D&w=1000&q=80',
      location: 'Toronto, Canada',
      state: 'Ontario',
      area: '1100 sq ft',
      price: '$500,000',
    },


    {
      id: 13,
      image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE0fHx8ZW58MHx8fHx8&w=1000&q=80',
      location: 'New York, USA',
      state: 'New York',
      area: '2100 sq ft',
      price: '$900,000',
    },
    {
      id: 14,
      image: 'https://www.cuded.com/wp-content/uploads/2013/04/Caruth-Boulevard-Residence-by-Tom-Reisenbichler-1.jpg',
      location: 'India, veermata jiajbai',
      state: 'Mumbai',
      area: '1000 sq ft',
      price: '$150,000',
    },
    {
      id: 15,
      image: 'https://i0.wp.com/movingtips.wpengine.com/wp-content/uploads/2021/02/contemporary-house.jpg?fit=400%2C684&ssl=1',
      location: 'India, moti chowk khagual',
      state: 'Bihar',
      area: '1000 sq ft',
      price: '$250,000',
    },


    {
      id: 16,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTjWmKwwR7h-_uD1MaeQbpOH36f_9XR_6p2WmKws0dR-hIl1KP5FXF5IlK6ZigGgjMNQ18&usqp=CAU',
      location: 'India, bally ghat',
      state: 'west bengal',
      area: '1000 sq ft',
      price: '$700,000',
    },
    {
      id: 17,
      image: 'https://i.pinimg.com/originals/d6/f3/ff/d6f3ffaaa50082552d3946734fa75e66.jpg',
      location: 'china,chang river near in northern bank',
      state: 'Beijing',
      area: '1000 sq ft',
      price: '$350,000',
    },
    {
      id: 18,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRNPHfaF1dHStiX5e1QDiio4fvXwIRbZyKQwOskC6c45ymyCfnOTqUuHVQjPzi7-kjV3jY&usqp=CAU',
      location: 'Toronto, Canada',
      state: 'Ontario',
      area: '1600 sq ft',
      price: '$550,000',
    },
    
  ]
  
  export default PropertyData;
  